import React, { useState } from "react";
import Les5C1 from "./les5-1";
export default function les5() {
  const [isShow, setisShow] = useState(true);
  return (
    <div>
      {isShow && <Les5C1 />}
      <button
        onClick={(e) => {
          e.preventDefault();
          setisShow(false);
        }}
      >
        Hide
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// src/page/les5.js